import React, { createContext, useContext, useState } from 'react';

type AIModelContextType = {
  selectedModel: string;
  setSelectedModel: (model: string) => void;
};

const AIModelContext = createContext<AIModelContextType | undefined>(undefined);

export const AIModelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedModel, setSelectedModel] = useState<string>('deepseek');

  return (
    <AIModelContext.Provider value={{ selectedModel, setSelectedModel }}>
      {children}
    </AIModelContext.Provider>
  );
};

export const useAIModel = () => {
  const context = useContext(AIModelContext);
  if (context === undefined) {
    throw new Error('useAIModel must be used within an AIModelProvider');
  }
  return context;
}; 